exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Day-5724a4d0{flex:1 0 0px;min-height:112px;min-width:0px;background-color:#fff;border-right:1px solid #E0E0E0;border-bottom:1px solid #E0E0E0}.label-cbd318a0{font-weight:500;font-size:13px;line-height:16px;padding:4px 4px 0px 4px;display:flex}.date-cc65fcee{padding:5px}.date-cc65fcee.current-7d20384a{background-color:#6982FF;color:#fff;border-radius:4px}.date-cc65fcee.hasColor-ca4ae5f0{background-color:'initial'}.events-3baffc73{padding-left:6px;padding-right:6px;padding-bottom:6px}.grey-4f9cd3f8{background-color:#f5f5f5}.rightAlign-919acb17{display:flex;justify-content:flex-end}.showMore-82866188{cursor:pointer;font-weight:500;font-size:13px;text-align:right}.EventsPopover-25f2b887{width:200px}.EventsPopover-25f2b887 .header-178a85d1{background:#6982FF;color:#FFF;font-weight:500;padding-top:10px;padding-bottom:10px;padding-left:15px;padding-right:15px;font-size:15px;width:200px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;border-radius:4px 4px 0 0}.EventsPopover-25f2b887 .eventsList-71aa1af1{padding:10px}\n", ""]);

// Exports
exports.locals = {
	"Day": "Day-5724a4d0",
	"label": "label-cbd318a0",
	"date": "date-cc65fcee",
	"current": "current-7d20384a",
	"hasColor": "hasColor-ca4ae5f0",
	"events": "events-3baffc73",
	"grey": "grey-4f9cd3f8",
	"rightAlign": "rightAlign-919acb17",
	"showMore": "showMore-82866188",
	"EventsPopover": "EventsPopover-25f2b887",
	"header": "header-178a85d1",
	"eventsList": "eventsList-71aa1af1"
};